import { Skeleton, Typography } from '@recruit-robin/robin-theme/web-components';
import { motion } from 'motion/react';

import { useDictionary } from '@/shared/lib/i18n';
import { useStyles } from './RobinLogoSkeleton.styles';

export const RobinLogoSkeleton = ({ position = 'inline' }: { position?: 'inline' | 'center' }) => {
  const dictionary = useDictionary();

  const classes = useStyles({ position });

  return (
    <motion.div css={classes.root} initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }}>
      <Skeleton variant="logo" size={128} />
      <Typography variant={(v) => v.supporting.label}>{dictionary.loading}...</Typography>
    </motion.div>
  );
};
